/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';
import { Container, Row } from '../../../styles/Grid';
import OffsetColumn from '../../ui/OffsetColumn';
import Picture from '../../ui/Picture';
import Spacer from '../../ui/Spacer';
import { Breakpoints } from '../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  imageCss,
  CaptionContainer,
  CaptionGuide,
  CaptionWrapperCss,
  containerMarginCss,
} from './index.styles';

const imageSizes = {
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 1058,
    height: 596,
    gravity: 'auto:subject',
    aspectRatio: '16:9',
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 687,
    height: 387,
    gravity: 'auto:subject',
    aspectRatio: '16:9',
  },
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 327,
    height: 184,
    gravity: 'auto:subject',
    aspectRatio: '16:9',
  },
};

export class Image extends SafePureComponent {
  safeRender() {
    const { fields } = this.props;

    return (
      <Spacer marginCss={containerMarginCss}>
        <Container>
          <Row>
            <OffsetColumn>
              <Picture
                image={fields.Image}
                imageSizes={imageSizes}
                imageCss={imageCss}
              />
              <div css={CaptionContainer}>
                {get(fields, 'Caption.value') && <span css={CaptionGuide} />}
                <div css={CaptionWrapperCss}>
                  <Text field={fields.Caption} />
                </div>
              </div>
            </OffsetColumn>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

Image.displayName = 'Image';

Image.propTypes = {
  fields: PropTypes.shape({
    Image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    Caption: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
};

export default Image;
